import { n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { useCreateRolePlayStore } from '../../../../store/useCreateRolePlayStore'
import FilterChip from '../../../portal/lesson/booking/TutorFilterControls/FilterChip'
import { purposeItems } from './content'
import { getPurposeName } from './getNames'

const Situation = () => {
  const {
    purposeIds,
    toggleSelection,
    showCustomPurpose,
    toggleShowCustomPurpose,
    customPurpose,
    setCustomPurpose,
    background,
    setBackground,
  } = useCreateRolePlayStore()

  const { locale, t } = useTranslation()

  return (
    <div style={{ position: 'relative', height: '100%', display: 'flex' }} className="flex-col ">
      <div className="p-[20px]">
        <span className="Headline3-22Bd">{t(n_ai_tutor.custom_roleplay.step2_title_1)}</span>
      </div>

      <div className="flex flex-col p-[24px]">
        <span className="Title2-18Bd">{t(n_ai_tutor.custom_roleplay.step2_sub_title_1)}</span>
        <div className="flex flex-wrap flex-row mt-[8px] gap-[8px]">
          {purposeItems.map((item) => (
            <FilterChip
              key={item.id}
              id={item.id.toString()}
              showIcon={false}
              name={getPurposeName(item.id, locale)}
              checked={purposeIds.includes(item.id)}
              onClick={() => toggleSelection(item.id)}
            />
          ))}

          {/* <br />
          <FilterChip
            id={'6'}
            name={getCustomPurpose(locale)}
            checked={showCustomPurpose}
            onClick={() => {
              toggleShowCustomPurpose()
            }}
          /> */}
        </div>
      </div>

      {/* 
      {showCustomPurpose && <TextField value={customPurpose} onChange={(e) => setCustomPurpose(e.target.value)} />}

      <br />
      <br />

      <span>사전배경</span>
      <br />
      <TextField
        multiline
        value={background}
        onChange={(e) => {
          setBackground(e.target.value)
        }}
      /> */}
    </div>
  )
}

export default Situation
